<template>
    <div class="roundAssets">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box1">
                <p class="title">资产管理现状及问题</p>
                <ul class="ul1">
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/ae91f2b1-26a7-4a0c-93dc-626a9809058d.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-title">资产状况不清晰</p>
                        <p class="li-info">资产履历不完整；资产账实不符；资产流失严重；资产闲置率高；资产重复采购</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/9c077c52-50f2-4ebe-8bfb-e775d7af5dbd.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-title">资产管理混乱</p>
                        <p class="li-info">资产派发认领混乱；资产借用、归还、调拨无监管；资产统计报表缺失</p>
                    </li>
                    <li>
                        <img src="http://img601.yun300.cn/repository/image/ce44e709-6fa0-4cfd-9d70-b241784e3eab.jpg?tenantId=214689&viewType=1&k=1651226704000" alt="">
                        <p class="li-title">盘点开展难</p>
                        <p class="li-info">盘点流程复杂、工作量大；盘点周期长、成本高；盘点出错率高，结果无法追溯</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="cont2">
            <p class="miderTitle">产品目标</p>
            <div class="box2">
                <div class="left">
                    <img src="https://nwzimg.wezhan.cn/contents/sitefiles2058/10294664/images/37662126.jpg" alt="">
                </div>
                <div class="right">
                    <p class="right-p">为企业打造一款基于钉钉的资产数字化管理平台，助力各企业实时掌握资产信息，解决资产管理难题，提升资产使用效率，发挥资产的最大价值。</p>
                    <p class="right-p">让固定资产物尽其用，让无形资产持续增值，让耗材合理配置。</p>
                </div>
                
            </div>

        </div>
        <div class="cont3">
            <p class="miderTitle">解决方案优势</p>
            <div class="line"></div>
            <p class="letter-title">让固定资产管理高效、可控，充分发挥资产的作用，降低企业运营成本。</p>
            <ul class="youshi">
                <li>
                    <div class="top">移动办公  简单易用</div>
                    <div class="bottom">
                        <p><span>·</span> 深度融合钉钉，简单便捷</p>
                        <p><span>·</span> 兼容多端，数据实时同步</p>
                        <p><span>·</span> 无纸化办公，绿色环保</p>
                        <p><span>·</span> 工作通知，信息实时送达</p>
                        <p><span>·</span> 操作留痕可追溯</p>
                    </div>
                </li>
                <li>
                    <div class="top">流程完整  驱动管理</div>
                    <div class="bottom">
                        <p><span>·</span> 全生命周期资产管理</p>
                        <p><span>·</span> 入库、派发、归还、报废全覆盖</p>
                        <p><span>·</span> 提高资产利用率，减少浪费</p>
                        <p><span>·</span> 提高资产流程处理效率</p>
                        <p><span>·</span> 权责清晰，责任到人</p>
                    </div>
                </li>
                <li>
                    <div class="top">全员盘点  智能高效</div>
                    <div class="bottom">
                        <p><span>·</span> 员工自助盘点</p>
                        <p><span>·</span> 手机端扫码盘点</p>
                        <p><span>·</span> 盘点结果审核制</p>
                        <p><span>·</span> 盘点报告自动生成，结果可靠</p>
                    </div>
                </li>
                <li>
                    <div class="top">统计图表  清晰易读</div>
                    <div class="bottom">
                        <p><span>·</span> 资产图表，多维度可视化</p>
                        <p><span>·</span> 资产状况一目了然</p>
                        <p><span>·</span> 兼顾全局与细节</p>
                        <p><span>·</span> 助力高效决策</p>
                        <p><span>·</span> 自定义设置，随需而动</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="cont4">
            <p class="miderTitle">产品介绍</p>
            <ul class="showChanpin">
                <li>
                    <div class="top-kuai">资产入库</div>
                    <div class="center-kuai">
                        <p class="one">支持多端操作：PC端 、手机端</p>
                        <p class="two">多种资产入库方式：逐个新增、批量导入、复制</p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/2d9a3200-ebfd-4590-9861-318989ba92cd.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
                <li>
                    <div class="top-kuai">资产清单</div>
                    <div class="center-kuai">
                        <p class="one">资产清单功能全面：资产清单一目了然、支持打印资产标签、支持资产快捷操作、支持查看</p>
                        <p class="two">入库记录</p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/b091f388-fa4c-455c-a082-cfddd317737d.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
                <li>
                    <div class="top-kuai">资产派发/申领</div>
                    <div class="center-kuai">
                        <p class="one">派发/申领：管理员派发、员工申领、线上认领，无纸化办公</p>
                        <p class="two"></p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/923d6d46-f19c-4972-98af-5c5def4c1c7b.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
                <li>
                    <div class="top-kuai">资产入库</div>
                    <div class="center-kuai">
                        <p class="one">支持多端操作：PC端 、手机端</p>
                        <p class="two">多种资产入库方式：逐个新增、批量导入、复制</p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/2d9a3200-ebfd-4590-9861-318989ba92cd.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
                <li>
                    <div class="top-kuai">资产盘点</div>
                    <div class="center-kuai">
                        <p class="one">盘点单类型：员工自助盘点、管理员手动盘点；盘点高效,可靠性高：自定义设置盘点范</p>
                        <p class="two">围、实施盘点结果审核制、生成盘点报告、盘点结果可追溯</p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/b091f388-fa4c-455c-a082-cfddd317737d.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
                <li>
                    <div class="top-kuai">资产统计图表</div>
                    <div class="center-kuai">
                        <p class="one">统计图表：资产分类统计、资产位置统计、员工资产统计</p>
                        <p class="two"></p>
                    </div>
                    <div class="bottom-kuai">
                        <img src="http://img601.yun300.cn/repository/image/923d6d46-f19c-4972-98af-5c5def4c1c7b.png?tenantId=214689&viewType=1&k=1651226704000" alt="">
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
        
<script>
export default {
   
}
</script>
<style lang='less' scoped>
.roundAssets{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 352px;
        background-image: url("customerLogo/yuangzichan.png");
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .cont1{
        width: 66%;
        height: 419px;
        margin:50px auto;
        .box1{
            width: 1200px;
            margin: auto;
            height: 100%;
            padding: 40px 100px;
            box-sizing: border-box;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            border-radius: 6px;
            p.title{
                font-size: 20px;
                color: #000;
                margin-bottom: 30px;
            }
            .ul1{
                width: 100%;
                height: 262px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 306px;
                    height: 141px;
                    img{
                        width: 100%;
                        height: 100%;
                        margin-bottom: 20px;
                    }
                    .li-title{
                        font-size: 18px;
                        text-align: center;
                        color: #000;
                        font-weight: bold;
                        margin-bottom: 18px;
                    }
                    .li-info{
                        font-size: 14px;
                        text-align: center;
                        color:#808080;
                        line-height: 24px;
                    }
                }
            }
        }
    }
    .cont2{
        width: 100%;
        // height: 468px;
        padding-top: 50px;
        padding-bottom: 2px;
        background-color: rgba(245, 245, 245, 1);
        .miderTitle{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 30px;
            // margin-top: 50px;
        }
        .box2{
            width: 1200px;
            background-color: #fff;
            margin: 30px auto 20px;
            margin-bottom: 50px;
            height: 318px;
            border-radius: 10px;
            padding: 10px;
            padding-right: 20px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            .left{
                width: 580px;
                height: 298px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            
            .right{
                width: 545px;
                height: 298px;
                margin-bottom: 20px;
                p{
                    font-size: 18px;
                    color: #000;
                    margin-top: 30px;
                    line-height: 40px;
                }
            }
        }
    }
    .cont3{
        .miderTitle{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 30px;
            margin-top: 50px;
        }
        .letter-title{
            font-size: 16px;
            text-align: center;
            color: #000;
            line-height: 30px;
            margin-top: 15px;
        }
        .line{
            width: 30px;
            height: 2px;
            background-color: rgba(0, 137, 255, 1);
            margin: 0 auto;
            margin-top: 12px;
        }
        .youshi{
            width: 66%;
            height: 290px;
            display: flex;
            justify-content: space-around;
            margin: 0 auto;
            margin-top: 18px;
            li{
                width: 299px;
                height: 266px;
                
                display: flex;
                flex-direction: column;
                .top{
                    width: 100%;
                    height: 64px;
                    font-size: 18px;
                    color: #fff;
                    text-align: center;
                    line-height: 64px;
                    background-color: rgba(0, 137, 255, 1);
                }
                .bottom{
                    width: 100%;
                    flex: 1;
                    padding: 20px;
                    border: 1px solid rgba(0, 137, 255, 1);
                    border-top: none;
                    p{
                        font-size: 16px;
                        color:#696969;
                        line-height: 28px;
                        span{
                            font-weight: bold;
                            font-size: 18px;
                        }
                    }
                }
            }
        }
    }
    .cont4{
        width: 100%;
        background-color: rgba(245, 245, 245, 1);
        .miderTitle{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 120px;
        }
        ul.showChanpin{
            width: 66%;
            margin: 0 auto;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            li{
                width: 600px;
                height: 381px;
                background-color: #fff;
                margin-bottom: 20px;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                .top-kuai{
                    width: 100%;
                    height: 54px;
                    line-height: 54px;
                    text-align: center;
                    color: #000;
                    font-weight: bold;
                    font-size: 18px;
                    background-color: rgba(0, 137, 255, 0.1);
                    border-radius: 10px 10px 0px 0px;
                }
                .center-kuai{
                    width: 100%;
                    height: 86px;
                    color:#696969;
                    font-size: 14px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 25px;
                }
                .bottom-kuai{
                    width: 100%;
                    height: 86px;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 561px;
                        height: 230px;
                    }
                }
            }
        }
    }
}
</style>